import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setBlockedPath,
  setLastAllowedPath,
  setModalOpen,
  setNavigationBlocked,
} from "../redux/reducers/controllNavigation";
import { store } from "../redux/store";
 
const useControlledNavigation = () => {
  const navigateHook = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const { isBlocked, lastAllowedPath } = useSelector((state) => state.controllNavigationSlice);
 
  
  const navigate = useCallback(
    (to, options = {}) => {
      const isBlocked = store.getState().controllNavigationSlice.isBlocked
      const shouldNavigate = options?.force || !isBlocked;
      if (shouldNavigate) {
        navigateHook(to, options);
        dispatch(setLastAllowedPath(to));
      } else {
        dispatch(setBlockedPath(to));
        dispatch(setModalOpen(true));
      }
    },
    [navigateHook, dispatch]
  );
 
  // useEffect(() => {
  //   if (isBlocked) {
  //     dispatch(setNavigationBlocked(false));
  //   }
  // }, [location.pathname, navigateHook, dispatch]);
 
 
  return navigate;
};
 
export default useControlledNavigation;